import LegalPage from '@/components/legal/LegalPage';
import { PRIVACY_TITLE, PRIVACY_LAST_UPDATED, PRIVACY_CONTENT } from '@/legal/privacy';

const PrivacyPolicy = () => (
  <LegalPage
    title={PRIVACY_TITLE}
    lastUpdated={PRIVACY_LAST_UPDATED}
    content={PRIVACY_CONTENT}
  />
);

export default PrivacyPolicy;
